import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppBubble } from './components/WhatsAppBubble';
import { QuickChatBubble } from './components/QuickChatBubble';
import { initializeDatabaseSync } from './services/firebaseSync';
import { ScrollToTop } from './components/ScrollToTop';

import { Suspense, lazy } from 'react';

// Lazy load Pages
const Home = lazy(() => import('./pages/Home').then(module => ({ default: module.Home })));
const CategoryPage = lazy(() => import('./pages/CategoryPage').then(module => ({ default: module.CategoryPage })));
const ProductDetail = lazy(() => import('./pages/ProductDetail').then(module => ({ default: module.ProductDetail })));
const Cart = lazy(() => import('./pages/Cart').then(module => ({ default: module.Cart })));
const Checkout = lazy(() => import('./pages/Checkout').then(module => ({ default: module.Checkout })));
const InvoicePage = lazy(() => import('./pages/InvoicePage').then(module => ({ default: module.InvoicePage })));
const Wholesale = lazy(() => import('./pages/Wholesale').then(module => ({ default: module.Wholesale })));
const Account = lazy(() => import('./pages/Account').then(module => ({ default: module.Account })));
const AiAssistant = lazy(() => import('./pages/AiAssistant').then(module => ({ default: module.AiAssistant })));
const CustomProjects = lazy(() => import('./pages/CustomProjects').then(module => ({ default: module.CustomProjects })));

// Admin
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard').then(module => ({ default: module.AdminDashboard })));

const StoreLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      <Navbar />
      <main className="flex-grow">{children}</main>
      <WhatsAppBubble />
      <QuickChatBubble />
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    initializeDatabaseSync();
  }, []);

  const adminPath = import.meta.env.VITE_ADMIN_PATH || 'admin';

  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div className="flex h-screen w-full items-center justify-center"><div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin"></div></div>}>
        <Routes>
          {/* Storefront Routes */}
          <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
          <Route path="/category/:catId" element={<StoreLayout><CategoryPage /></StoreLayout>} />
          <Route path="/product/:prodId" element={<StoreLayout><ProductDetail /></StoreLayout>} />
          <Route path="/cart" element={<StoreLayout><Cart /></StoreLayout>} />
          <Route path="/checkout" element={<StoreLayout><Checkout /></StoreLayout>} />
          <Route path="/invoice/:orderId" element={<InvoicePage />} />
          <Route path="/wholesale" element={<StoreLayout><Wholesale /></StoreLayout>} />
          <Route path="/account" element={<StoreLayout><Account /></StoreLayout>} />
          <Route path="/ai-assistant" element={<StoreLayout><AiAssistant /></StoreLayout>} />
          <Route path="/custom-projects" element={<StoreLayout><CustomProjects /></StoreLayout>} />

          {/* Admin Dashboard Routes */}
          <Route path={`/${adminPath}`} element={<AdminDashboard />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

